import * as React from "react"
import { FormattedMessage } from "react-intl"
import { Container, Row, Col } from "reactstrap"
import "./footer.css"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import AppConfig from "../../configs/AppConfig"
import HomeCookie from "../../components/cookie/cookie"
import { connect } from "react-redux"
import SagaAuthRedux from "../../redux/sagaAuth/sagaAuthRedux"

class Footer extends React.Component<
  {
    language: string
    requestSaveCookie: () => void
    cookie: boolean
  },
  any
> {
  constructor(props) {
    super(props)
  }

  public render() {
    return (
      <section id="footer">
        <Container className="hiso-bus-rental-font-quark-blod">
          <Row className="pb-4">
            <Col className="text-left">
              <Row className="pb-0 text-lg-left mx-2">
                <Col>
                  <img
                    src={require("../../images/footer-logo.png")}
                    alt="vecabo logo"
                  />
                </Col>
              </Row>
              <Row id="footer-company-address" className="text-lg-left mx-2">
                <Col>
                  <p className="hiso-bus-header-second">
                    © <FormattedMessage id="copyright" /> 2019 VECABO
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="pb-4">
            <Col xs={12}>
              <Row id="footer-company-address" className="mx-2 text-md-left">
                <Col xs={12} md={4} className="pb-md-0 pb-4">
                  <p className="hiso-bus-header-second pb-md-4 pb-2">
                    <FormattedMessage id="HISOBUS" />
                  </p>
                  <p>
                    <Link to={`/${this.props.language}/aboutus`}>
                      <FormattedMessage id="Footer.Why" />
                    </Link>
                  </p>
                  <p>
                    <Link to={`/${this.props.language}/contactus`}>
                      <FormattedMessage id="Footer.ContactUs" />
                    </Link>
                  </p>
                  <p>
                    <Link to={`/${this.props.language}/faq`}>
                      <FormattedMessage id="Faq" />
                    </Link>
                  </p>
                  <p>
                    <Link to={`/${this.props.language}/blog`}>
                      <FormattedMessage id="Footer.News" />
                    </Link>
                  </p>
                </Col>
                <Col xs={12} md={4} className="pb-md-0 pb-4">
                  <p className="hiso-bus-header-second pb-md-4 pb-2">
                    <FormattedMessage id="Services" />
                  </p>
                  <p>
                    <Link to={`/${this.props.language}/Pricing`}>
                      <FormattedMessage id="Pricing" />
                    </Link>
                  </p>
                  <p>
                    <Link to={`/${this.props.language}/howtopay/`}>
                      <FormattedMessage id="HowToPay" />
                    </Link>
                  </p>
                  <p>
                    <Link to={`/${this.props.language}/businessregister`}>
                      <FormattedMessage id="businessRegister" />
                    </Link>
                  </p>
                  <p>
                    <Link to={`/${this.props.language}/PartnerWithUs`}>
                      <FormattedMessage id="PartnerWithUs" />
                    </Link>
                  </p>
                  <p>
                    <Link to={`/${this.props.language}/complain`}>
                      <FormattedMessage id="complain" />
                    </Link>
                  </p>
                  <p>
                    <Link to={`/${this.props.language}/busstandard`}>
                      <FormattedMessage id="busstandard" />
                    </Link>
                  </p>
                  {/* <p>ช่องทางการชำระเงิน</p> */}
                </Col>
                <Col xs={12} md={4} className="pb-md-0 pb-4">
                  <p className="hiso-bus-header-second pb-md-4 pb-2">
                    <FormattedMessage id="customerservice" />
                  </p>
                  <p>
                    <FormattedMessage id="Footer.CompanyAddress1" />{" "}
                    <FormattedMessage id="Footer.CompanyAddress2" />{" "}
                    <FormattedMessage id="Footer.CompanyAddress3" />
                  </p>
                  <p>
                    <a href="https://line.me/ti/p/~@vecabo" target="_blank">
                      <i style={{ fontSize: 27, paddingRight: 5 }}>
                        <FontAwesomeIcon icon={["fab", "line"]} />
                      </i>{" "}
                      @vecabo
                    </a>
                  </p>
                  <p>
                    <a
                      href="https://www.facebook.com/vecabotrans"
                      target="_blank"
                    >
                      <i
                        style={{
                          fontSize: 27,
                          paddingLeft: 5,
                          paddingRight: 5
                        }}
                      >
                        <FontAwesomeIcon icon={["fab", "facebook-f"]} />
                      </i>{" "}
                      Vecabo
                    </a>
                  </p>
                  <p>
                    <i style={{ fontSize: 27, paddingRight: 5 }}>
                      <FontAwesomeIcon icon={["far", "envelope"]} />
                    </i>{" "}
                    info@vecabo.com
                  </p>
                  <p>
                    <a href="tel:02-0803972">
                      <i style={{ fontSize: 27, paddingRight: 5 }}>
                        <FontAwesomeIcon icon={["fas", "phone"]} />
                      </i>{" "}
                      02-0803972
                    </a>
                  </p>
                  <p>
                    <i style={{ fontSize: 27, paddingRight: 5 }}>
                      <FontAwesomeIcon icon={["fas", "building"]} />
                    </i>{" "}
                    <FormattedMessage id="workinghour" />
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        {/* hide orange cookie agreement */}
        {/* {!this.props.cookie && (
          <HomeCookie
            locale={this.props.language}
            onAction={() => this.props.requestSaveCookie()}
          />
        )} */}
      </section>
    )
  }
}
const mapStateToProps = state => {
  return {
    cookie: state.SagaAuth.cookie
  }
}

const mapDispatchToProps = dispatch => {
  return {
    requestSaveCookie: () => dispatch(SagaAuthRedux.requestSaveCookie())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer)



// WEBPACK FOOTER //
// ./src/components/footer/footer.tsx